import { useState } from "react";
import { Alert, Box, Button, Snackbar } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import NewDashboardPage from "../../NewDashboardPage/newdashboard";
import EquipmentCsvImportDialog from "./EquipmentCsvImportDialog";

function MachinesTab(props) {
  const i18n = useSelector((state) => state.i18n);
  const [dashboardKey, setDashboardKey] = useState(0);
  const [activeEquipmentPool, setActiveEquipmentPool] = useState(null);
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const [feedback, setFeedback] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const handleOpenImportDialog = (equipmentPool) => {
    setActiveEquipmentPool(equipmentPool);
    setIsImportDialogOpen(true);
  };

  return (
    <Box sx={{ p: 3 }}>
      <NewDashboardPage
        key={dashboardKey}
        zeroPadding
        customerNodeId={props.customerNodeId}
        renderSectionAction={(section) =>
          section?.type === "pool" ? (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() =>
                handleOpenImportDialog({
                  nodeid: section.nodeid,
                  name: section.name,
                })
              }
              sx={{
                minWidth: 92,
                height: 40,
                boxShadow: "0px 2px 6px rgba(0,0,0,0.18)",
                flexShrink: 0,
              }}
            >
              {i18n.users.addNew.replace("+ ", "")}
            </Button>
          ) : null
        }
      />
      <EquipmentCsvImportDialog
        open={isImportDialogOpen}
        equipmentPool={activeEquipmentPool}
        i18n={i18n}
        onClose={() => {
          setIsImportDialogOpen(false);
          setActiveEquipmentPool(null);
        }}
        onImportSuccess={({ successCount, errorCount }) => {
          const successMessage =
            i18n.customer_details_csv_import_feedback_success.replace(
              "%s",
              successCount
            );
          const partialMessage =
            i18n.customer_details_csv_import_feedback_partial
              .replace("%s", successCount)
              .replace("%s", errorCount);

          setFeedback({
            open: true,
            severity: errorCount ? "warning" : "success",
            message: errorCount
              ? partialMessage
              : successMessage,
          });
          setDashboardKey((current) => current + 1);
        }}
      />
      <Snackbar
        open={feedback.open}
        autoHideDuration={3200}
        onClose={() => setFeedback((current) => ({ ...current, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() =>
            setFeedback((current) => ({ ...current, open: false }))
          }
          severity={feedback.severity}
          variant="filled"
        >
          {feedback.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default MachinesTab;
